<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import mixin from './../mixin';

    export default defineComponent({
        mixins: [mixin],
        props: {
            imageSets: {
                type: Array as PropType<any[]>,
                required: true,
            },
            pictureClass: {
                type: String,
                required: false,
                default: 'image is-clipped',
            },
        },
        computed: {
            lastImage(): any | null {
                return this.imageSets?.[0]?.images?.length ? this.imageSets[0].images[this.imageSets[0].images.length - 1] : null;
            },
            lastWidth(): number {
                return this.lastImage?.displayWidth || 0;
            },
            lastHeight(): number {
                return this.lastImage?.displayHeight || 0;
            },
        },
        methods: {
            toMediaQuery(mediaString: string): string {
                if (!mediaString) return '';
                return mediaString.split('"')[1];
            },
            onError(event: Event): void {
                const img = event.target as HTMLImageElement;

                img.onerror = null;
                img.style.backgroundColor = '#cccccc';
            }
        },
    });
</script>

<template>
    <picture :class="pictureClass">
        <source v-for="(format, index) in reverse(imageSets[0].images)"
                :key="index"
                type="image/webp"
                :srcset="format.webPUrl"
                :sizes="format.displayWidth + 'px'"
                :media="toMediaQuery(format.mediaQuery)" />
        <img :src="imageSets[0].images[0].defaultCropUrlJpeg"
             :alt="imageSets[0].imageAlt"
             :width="lastWidth"
             :height="lastHeight"
             @error="onError" />
    </picture>
</template>
